import React from 'react';

const About = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="bg-black text-white p-4">
        <div className="container mx-auto">
          <h1 className="text-3xl font-bold text-center">À propos d'EasySyntaxe</h1>
        </div>
      </header>
      <main className="flex-grow container mx-auto px-4 py-8">
        <section className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-4">Qui sommes-nous ?</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            <span className='font-bold'>EasySyntaxe</span> est un outil gratuit qui facilite l'accès aux syntaxes des opérateurs de télécommunications de Côte d'Ivoire! <br /><br /> Nous croyons fermement que ces informations doivent être accessibles à tous, et nous faisons de notre mieux pour y parvenir !<br /><br />
            Par conséquent, si vous constatez qu'une syntaxe d'un de vos opérateurs manque dans notre base de données, n'hésitez pas à nous aider à enrichir notre outil. Vous pouvez nous contacter via notre support technique pour signaler toute syntaxe manquante. <br /><br /> Votre contribution est précieuse et nous permet de garder <span className='font-bold'>EasySyntaxe</span> à jour et utile pour tous.
            Merci de faire partie de notre communauté et d'aider à démocratiser l'accès aux <span className='font-bold'>codes USSD !</span>
          </p>
        </section>
        <section className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-4">Voici comment utiliser EasySyntaxe</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            EasySyntaxe fonctionne de manière simple et intuitive :
          </p>
          <div className="text-center mt-8">
            <div className="flex flex-col items-center space-y-8">
              <div className="flex flex-col items-center">
                <div className="bg-black text-white rounded-full w-10 h-10 flex items-center justify-center mb-2">1</div>
                <p className="text-lg text-gray-600 max-w-xs">Utilisez la barre de recherche pour trouver rapidement une syntaxe spécifique.</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="bg-black text-white rounded-full w-10 h-10 flex items-center justify-center mb-2">2</div>
                <p className="text-lg text-gray-600 max-w-xs">Parcourez les différents opérateurs disponibles et cliquez sur celui qui vous intéresse.</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="bg-black text-white rounded-full w-10 h-10 flex items-center justify-center mb-2">3</div>
                <p className="text-lg text-gray-600 max-w-xs">Explorez la liste complète des syntaxes pour chaque opérateur.</p>
              </div>
            </div>
          </div>
          <div className="w-24 h-1 bg-gray-400 mx-auto my-8"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Notre interface réactive s'adapte à tous les appareils, vous permettant d'accéder aux syntaxes où que vous soyez, que ce soit sur ordinateur, tablette ou smartphone.
          </p>
        </section>
      </main>
    </div>
  );
};

export default About;
